import { useMutation } from "react-query"
import api from "../client"
import { ChangePasswordPayload } from "../types/user"
import { ResponseData } from "../types/base"

const postData = async (id: string | undefined, payload: ChangePasswordPayload) => {
  const { data } = await api.post<ResponseData>(
    `/users/${id}/change-password`,
    payload
  )
  return data
}

export const useChangePassword = (id: string | undefined) => {
  return useMutation((payload: ChangePasswordPayload) => {
    return postData(id, payload)
  })
}
